import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container relative hidden h-[100vh] flex-col items-center justify-center md:grid lg:max-w-none lg:grid-cols-2 lg:px-0" }
const _hoisted_2 = { class: "relative hidden h-full flex-col bg-muted p-10 text-white dark:border-r lg:flex" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 signin-bg" }, null, -1)
const _hoisted_4 = { class: "relative z-20 mt-auto" }
const _hoisted_5 = { class: "space-y-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg bg-black bg-opacity-40 p-2" }, [
  /*#__PURE__*/_createTextVNode(" “Salvaguardia su Misura: Proteggi il Tetto, Preserva il Futuro”"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Questo slogan mette in luce l'importanza della personalizzazione del servizio, la protezione dell'edificio e la visione a lungo termine, tutti elementi chiave per la manutenzione dei tetti. ")
], -1)
const _hoisted_7 = { class: "text-lg bg-black bg-opacity-40 p-2" }
const _hoisted_8 = { class: "lg:p-8" }
const _hoisted_9 = { class: "mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]" }
const _hoisted_10 = { class: "flex flex-col space-y-2 text-center" }
const _hoisted_11 = { class: "text-2xl font-semibold tracking-tight" }
const _hoisted_12 = { class: "text-sm text-muted-foreground" }

import SigninForm from "@/components/signin/SigninForm.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SigninView',
  setup(__props) {

  const version = process.env.VUE_APP_VERSION;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("blockquote", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("p", _hoisted_7, " Software version: " + _toDisplayString(_unref(version)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.$t('login.login')), 1),
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('login.subtitle')), 1)
        ]),
        _createVNode(SigninForm)
      ])
    ])
  ]))
}
}

})